/* eslint-disable @typescript-eslint/no-explicit-any */
export interface CustomEventProps {
  event: string;
  eventLabel: string;
  page: {
    title?: string;
    url?: string;
  };
}

export const sendCustomEvent = (event: CustomEventProps & any): void => {
  if (typeof window !== 'undefined') {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      ...event,
    });
  }
};

export const customEvents = {
  ARTICLE_CLICK: 'article_click',
  HERO_ARTICLE_VIEW: 'hero_article_view',
} as const;
